import { jsx, jsxs } from "react/jsx-runtime";
import AntEmpty from "antd/es/empty";
import classnames from "../../utils/classnames.js";
import Col from "../Grid/Col.js";
import "react";
import Row from "../Grid/Row.js";
import './Empty.css';import '../Grid/Grid.css';/* empty css                */
import Typography from "../Typography/Typography.js";
/* empty css           */
const Empty = ({
  title,
  description,
  align = "center",
  className,
  children,
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    AntEmpty,
    {
      image: null,
      description: /* @__PURE__ */ jsxs(Row, { gutter: [0, "vertical-sky"], children: [
        /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Typography.Title, { level: "h2", headingLevel: 4, color: "darkest", children: title }) }),
        !!description && /* @__PURE__ */ jsx(Col, { span: 24, children: /* @__PURE__ */ jsx(Typography.Text, { level: "main", color: "dark", children: description }) })
      ] }),
      className: classnames(["perxis-auto-empty", `perxis-auto-empty-align-${align}`], className),
      ...props,
      children
    }
  );
};
export {
  Empty as default
};
//# sourceMappingURL=Empty.js.map
